import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store' // 添加这行导入 store

Vue.use(Router)

// 解决Vue-Router升级导致的Uncaught(in promise) NavigationDuplicated问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
        // 处理重复导航
        return {name: 'NavigationDuplicated', msg: location}
    })
}


let baseRoutes = [
    {
        path: '/',
        name: 'home',
        meta: {
            title: '化联网官网 | 化工原料交易 | 原料中间体 | 化工免费资源对接', // 页面标题
            description: '化联网官网打造化工 B2B 精准撮合平台，为医药、化工原料、农药、涂料等行业用户，提供化工品供需信息展示、询单精准匹配、在线交易结算等服务，助力企业高效对接资源。', // 页面描述
            login: false
        },
        component: () => import("@/views/home/Home")
    },
    {
        path: '/wechat/callback',
        name: 'wechat',
        meta: {
            title: "回调页面",
            login: false,
        },
        component: () => import("@/views/homePage/index")
    },
    {
        path: '/shop',
        name: 'shop',
        meta: {
            title: "化联网试剂商城 - 科研 / 工业级化工试剂采购_高纯度试剂精准匹配",
            description: '化联网试剂商城是专业化工试剂采购渠道，覆盖科研、工业级高纯度化工试剂，提供试剂供需匹配、资质核验、现货供应服务，满足医药、实验室、化工企业的精准采购需求。', // 页面描述
            login: false,
        },
        component: () => import("@/views/homePage/shop")
    },
    {
        path: '/shop/settlement',
        name: 'settlement',
        meta: {
            title: "结算中心",
            login: true,
        },
        component: () => import("@/views/homePage/shop/settlement")
    },
    {
        path: '/shop/shopDetail',
        name: 'shop-detail',
        meta: {
            title: "商品详情",
            login: false,
        },
        component: () => import("@/views/homePage/shop/shopDetail")
    },
    {
        path: '/shop/car',
        name: 'car',
        meta: {
            title: "购物车",
            login: true,
        },
        component: () => import("@/views/homePage/shop/car")
    },
    {
        path: '/shop/list',
        name: 'shop-list',
        meta: {
            title: "商品列表",
            login: false,
        },
        component: () => import("@/views/homePage/shop/list")
    },
    {
        path: '/shop/bay',
        name: 'bay',
        meta: {
            title: "付款",
            login: true,
        },
        component: () => import("@/views/homePage/shop/bay")
    },
    {
        path: '/shop/success',
        name: 'success',
        meta: {
            title: "支付成功",
            login: false,
        },
        component: () => import("@/views/homePage/shop/success")
    },
    {
        path: '/search',
        name: 'search',
        meta: {
            title: "商品详情",
            login: false,
        },
        component: () => import("@/views/homePage/search")
    },
    {
        path: '/search-page',
        name: 'search-page',
        meta: {
            title: "搜索",
            login: false,
        },
        component: () => import("@/views/homePage/search-page")
    },
    {
        path: '/purchase',
        name: 'purchase',
        meta: {
            title: "化联网原料采购专区 - 化工原料精准采购_多品类原料供需匹配_企业直采平台",
            description: '化联网原料采购专区，聚焦化工原料精准采购场景，覆盖医药原料、农药原料、涂料原料等多品类，提供供应商资质核验、询单快速报价、交易担保服务，让化工企业直采更高效。', // 页面描述
            login: false,
        },
        component: () => import("@/views/homePage/purchase")
    },
    {
        path: '/supply',
        name: 'supply',
        meta: {
            title: "化联网原料供应专区 - 化工原料供应展示_供应商免费入驻_精准询单对接",
            description: '化工原料供应专区、化工原料供应商入驻、化工原料供应展示、原料询单对接、化工供应商拓展渠道', // 页面描述
            login: false,
        },
        component: () => import("@/views/homePage/supply")
    },
    {
        path: '/technology',
        name: 'technology',
        meta: {
            title: "化联网技术项目交易 - 化工技术合作_项目转让_技术成果对接平台",
            description: '化工技术项目交易、化工技术合作、化工项目转让、技术成果对接、化工技术产业化',
            login: false,
        },
        component: () => import("@/views/homePage/technology")
    },
    {
        path: '/technology/detail',
        name: 'technology-detail',
        meta: {
            title: "技术交易详情",
            login: false,
        },
        component: () => import("@/views/homePage/technology/detail")
    },
    {
        path: '/ruitian-news',
        name: 'ruitian-news',
        meta: {
            title: "化联网化工资讯 - 化工行业动态_政策解读_市场行情_技术趋势分析",
            description: '化工资讯、化工行业动态、化工政策解读、化工原料市场行情、化工技术趋势', // 页面描述
            login: false,
        },

        component: () => import("@/views/homePage/ruitian-news")
    },
    {
        path: '/about-us',
        name: 'about-us',
        meta: {
            title: "化联网官网 - 关于我们_专业化工 B2B 撮合平台_企业资质与服务理念",
            description: '化联网介绍、化工 B2B 平台资质、化联网服务理念、化工撮合平台实力、化工企业资源对接解决方案', // 页面
            login: false,
        },

        component: () => import("@/views/homePage/about-us")
    },
    {
        path: '/industry-tools',
        name: 'industry-tools',
        meta: {
            title: "化联网行业工具 - 化工查询工具_采购报价计算器_化工标准查询_行业实用工具合集",
            description: '化工行业工具、化工产品查询工具、采购报价计算器、化工 CAS 号查询、化工标准查询工具', // 页面描述
            login: false,
        },
        component: () => import("@/views/homePage/industry-tools")
    },
    {
        path: '/project-transaction',
        name: 'project-transaction',
        meta: {
            title: "化联网来料加工 - 化工来料加工对接_定制化加工服务_企业加工需求匹配",
            description: '化联网来料加工板块，专注化工来料加工对接场景，连接化工企业加工需求与优质加工厂商，提供定制化加工服务、加工资质核验、流程监管服务，保障加工合作高效落地。', // 页面描述
            login: false,
        },
        component: () => import("@/views/homePage/project-transaction")
    },
    {
        path: '/agreement/agreement',
        name: 'agreement',
        meta: {
            title: "协议",
            login: false,
        },
        component: () => import("@/views/homePage/agreement/agreement")
    },
    {
        path: '/agreement/findPassword',
        name: 'find-password',
        meta: {
            title: "找回密码",
            login: false,
        },
        component: () => import("@/views/homePage/agreement/findPassword")
    },
    {
        path: '/shop/pay-success',
        name: 'pay-success',
        meta: {
            title: "支付成功",
            login: false,
        },
        component: () => import("@/views/homePage/shop/pay-success")
    },
    {
        path: '/ruitian-news/news-detail',
        name: 'news-detail',
        meta: {
            title: "新闻详情",
            login: false,
        },
        component: () => import("@/views/homePage/news/news-detail")
    },
        {
        path: '/ruitian/swiper-detail',
        name: 'swiper-detail',
        meta: {
            title: "轮播图详情",
            login: false,
        },
        component: () => import("@/views/homePage/news/swiper-detail.vue")
    },
    {
        path: '/message',
        name: 'message',
        meta: {
            title: "全屏聊天",
            login: false,
        },
        component: () => import("@/views/homePage/message")
    },
    {
        path: '/project/factory',
        name: 'factory',
        meta: {
            title: "需求方详情",
            login: false,
        },
        component: () => import("@/views/homePage/project/factory")
    },
    {
        path: '/project/demand',
        name: 'demand',
        meta: {
            title: "需求方详情",
            login: false,
        },
        component: () => import('@/views/homePage/project/demand') // 添加 .vue 后缀
    },
    {
        path: '/project/more',
        name: 'more',
        meta: {
            title: "查看更多",
            login: false,
        },
        component: () => import('@/views/homePage/project/more') // 添加 .vue 后缀
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: "登录",
            login: false,
        },
        component: () => import("@/views/login/Login")
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: "注册",
            login: false,
        },
        component: () => import("@/views/login/Register")
    },
    {
        path: '/bindPhone',
        name: 'bindPhone',
        meta: {
            title: "绑定手机号",
            login: false,
        },
        component: () => import("@/views/login/bindPhone")
    },
    {
        path: '/bindWechat',
        name: 'bindWechat',
        meta: {
            title: "绑定微信",
            login: true,
        },
        component: () => import("@/views/homePage/agreement/bindWechat")
    },
    {
        path: '/vip/vip',
        name: 'vip',
        meta: {
            title: "vip",
            login: false,
        },
        component: () => import("@/views/homePage/vip/vip")
    },
    {
        path: '/vip/upgrade',
        name: 'upVip',
        meta: {
            title: "upVip",
            login: false,
        },
        component: () => import("@/views/homePage/vip/upgrade")
    },
    {
        path: '/vip/vipSuc',
        name: 'vipSuc',
        meta: {
            title: "vipSuc",
            login: false,
        },
        component: () => import("@/views/homePage/vip/vipSuc")
    },
    {
        path: '/vip/svipSuc',
        name: 'svipSuc',
        meta: {
            title: "svipSuc",
            login: false,
        },
        component: () => import("@/views/homePage/vip/svipSuc")
    },
    {
        path: '/operate/applyInvoice',
        name: 'apply-invoice',
        meta: {
            title: "申请发票",
            login: true,
        },
        component: () => import("@/views/homePage/operate/applyInvoice")
    },
    {
        path: '/operate/sendGoods',
        name: 'send-goods',
        meta: {
            title: "发货",
            login: true,
        },
        component: () => import("@/views/homePage/operate/sendGoods")
    },

    {
        path: '/user/index',
        name: 'user-index',
        meta: {
            title: "化联网用户中心",
            description: '化联网用户中心 - 个人 / 企业账户管理_订单跟踪_供需信息管理_交易记录查询，化联网用户中心、化工订单跟踪、供需信息管理、化工交易记录查询、企业账户管理', // 页面描述
        },
        component: () => import("@/views/user/index"),
        children: [
            {
                path: '/user/user-center',
                name: 'user-center',
                meta: {
                    title: "个人中心",
                    login: true,
                },
                component: () => import("@/views/user/user-center.vue")
            },
            {
                path: '/user/purchase/post',
                name: 'user-post',
                meta: {
                    title: "询单管理",
                    login: true,
                },
                component: () => import("@/views/user/purchase/post")
            },
            {
                path: '/user/purchase/order',
                name: 'user-order',
                meta: {
                    title: "成交订单",
                    login: true,
                },
                component: () => import("@/views/user/purchase/order")
            },
            {
                path: '/user/purchase/release',
                name: 'user-release',
                meta: {
                    title: "发布询单",
                    login: true,
                },
                component: () => import("@/views/user/purchase/release")
            },
            {
                path: '/user/process',
                name: 'user-process',
                meta: {
                    title: "加工供需管理",
                    login: true,
                },
                component: () => import("@/views/user/process")
            },
            {
                path: '/user/technology',
                name: 'user-technology',
                meta: {
                    title: "技术项目交易",
                    login: true,
                },
                component: () => import("@/views/user/technology")
            },
            {
                path: '/user/base-info',
                name: 'user-base-info',
                meta: {
                    title: "基本资料",
                    login: true,
                },
                component: () => import("@/views/user/base-info")
            },
            {
                path: '/user/supplier/my-project',
                name: 'user-my-project',
                meta: {
                    title: "我的产品",
                    login: true,
                },
                component: () => import("@/views/user/supplier/my-project")
            },

            {
                path: '/user/supplier/sale-order',
                name: 'user-sale-order',
                meta: {
                    title: "销售订单",
                    login: true,
                },
                component: () => import("@/views/user/supplier/sale-order")
            },
            {
                path: '/user/supplier/quotation',
                name: 'user-quotation',
                meta: {
                    title: "报价管理",
                    login: true,
                },
                component: () => import("@/views/user/supplier/quotation")
            },
            {
                path: '/user/message/mail',
                name: 'user-mail',
                meta: {
                    title: "站内信",
                    login: true,
                },
                component: () => import("@/views/user/message/mail")
            },
            {
                path: '/user/message/message-counter',
                name: 'user-message-counter',
                meta: {
                    title: "推送设置",
                    login: true,
                },
                component: () => import("@/views/user/message/message-counter")
            },
            {
                path: '/user/message/complaint',
                name: 'user-message-complaint',
                meta: {
                    title: "投诉建议",
                    login: true,
                },
                component: () => import("@/views/user/message/complaint")
            },
            {
                path: '/user/message/mail-detail',
                name: 'user-mail-detail',
                meta: {
                    title: "消息详情",
                    login: true,
                },
                component: () => import("@/views/user/message/mail-detail")
            },
            {
                path: '/user/purchase/bay',
                name: 'user-bay',
                meta: {
                    title: "立即购买",
                    login: true,
                },
                component: () => import("@/views/user/purchase/bay")
            },
            {
                path: '/user/purchase/pay/:id/:order_id',
                name: 'user-pay',
                meta: {
                    title: "付款",
                    login: true,
                },
                component: () => import("@/views/user/purchase/pay")
            }

        ],
    },
]

let routes = [...baseRoutes]

//自动扫描router下子模块并导入
const routerContext = require.context("./", true, /index\.js$/);
routerContext.keys().forEach(route => {
    // 如果是根目录的index.js 则不处理
    if (route.startsWith("./index")) {
        return;
    }
    const routerModule = routerContext(route);
    /**
     * 兼容import export 和 require module.export 两种规范
     */
    routes = [...routes, ...(routerModule.default || routerModule)];
});
// 兜底与空路径重定向到首页
routes.push({path: '', redirect: '/'})
routes.push({path: '*', redirect: '/'})

export default new Router({
    routes: routes,
    // mode: 'history',

    // 添加滚动行为配置
    scrollBehavior(to, from, savedPosition) {
        // 默认滚动到顶部
        return {
            x: 0,
            y: 0,
            behavior: 'smooth'
        }
    }
})
